import React, { useCallback } from 'react';
import CloseIcon from 'mdi-react/CloseIcon';
import { useDispatch } from 'react-redux';

import { IconButton } from '@crm-framework/icon-button';
import { Spacing } from '@crm-framework/spacing';
import { InlineNotifications } from '@crm-framework/inline-notifications';
import { registryActions } from '@crm-framework/registry';
import { InlineNotificationsTypes } from '@crm-framework/inline-notifications/src/types';

import { TOOLS_REGISTERS } from '../consts';

import { NotificationButtonWrapper } from './styled';

function getStatus(status: string): InlineNotificationsTypes {
  switch (status) {
    case 'OK':
      return 'success';
    case 'error':
      return 'danger';
    default:
      return 'danger';
  }
}

interface INotificationProps {
  response: any;
}

export const ToolsNotification: React.FC<INotificationProps> = ({
  response,
  children,
}) => {
  const dispatch = useDispatch();

  const closeNotification = useCallback(() => {
    dispatch(registryActions.remove(TOOLS_REGISTERS.withdrawalResponse));
  }, []);

  return (
    <Spacing mb={30}>
      <InlineNotifications type={getStatus(response.status)} showIcon>
        <Spacing mr={10}>
          <strong>
            {response.status === 'OK' && 'Success! '}
            {response.status === 'error' && 'Error! '}
          </strong>
        </Spacing>
        {children}
        <NotificationButtonWrapper>
          <IconButton icon={CloseIcon} onClick={closeNotification} />
        </NotificationButtonWrapper>
      </InlineNotifications>
    </Spacing>
  );
};
